
import { Component, Vue, Prop } from "vue-property-decorator";
import BasicTitle from "../components/basic-title.vue";
import HinaUpload from "../baseComponent/hina-upload.vue";
import HinaSwitch from "../baseComponent/hina-switch.vue";
import HinaRadioGroup from "../baseComponent/hina-radio-group.vue";
import HinaColorPicker from "../baseComponent/color-picker/hina-color-picker.vue";
import HinaColorRangePicker from "../baseComponent/color-picker/hina-color-range-picker.vue";
import IntroduceCard from "@/views/ai-builder-component/components/introduce-card.vue";

@Component({
  components: {
    BasicTitle,
    HinaColorPicker,
    HinaColorRangePicker,
    HinaRadioGroup,
    HinaUpload,
    HinaSwitch,
    IntroduceCard
  }
})
export default class examRoomStyle extends Vue {
  @Prop() formItemData!: any; // 组件数据

  urlTemp = "";
  hasChecked = false;

  logoSelectOptions = [
    { name: "展示", value: true },
    { name: "不展示", value: false }
  ];

  fontSizeSelectOptions = [
    { name: "标准", value: 16, class: "normal" },
    { name: "大字版", value: 18, class: "large" },
    { name: "超大字版", value: 20, class: "xlarge" }
  ];

  sectionOptions = [
    { name: "图文版", value: 1 },
    { name: "虚拟人版", value: 2 }
  ];

  showLogo = !!this.formItemData.styleConfig.logoUrl;

  reset(): void {
    this.formItemData.styleConfig.mainColor = "#525fff";
    this.formItemData.styleConfig.coverColor = "#F1F2FF";
    this.$set(this.formItemData.styleConfig.backgroundColor, "from", "#525fff");
    this.$set(this.formItemData.styleConfig.backgroundColor, "to", "#606DFC");
    this.formItemData.styleConfig.logoUrl = "";
    this.formItemData.styleConfig.fontSize = 16;
    this.formItemData.styleConfig.needProcessBar = 1;
    this.formItemData.styleConfig.sectionPageType = 2;
    this.showLogo = false;
  }

  // 校验数据：
  //    (1) 校验不通过，返回 false
  //    (2) 校验通过，返回 true
  formItemCheck(): Promise<string> {
    this.hasChecked = true;
    return new Promise(resolve => {
      if (this.showLogo && !this.formItemData.styleConfig.logoUrl) {
        resolve("examRoomStyle");
      }
      resolve("");
    });
  }

  handleChange(val: boolean): void {
    if (val) {
      this.showLogo = true;
      this.formItemData.styleConfig.logoUrl = this.urlTemp;
      this.urlTemp = "";
    } else {
      this.showLogo = false;
      this.urlTemp = this.formItemData.styleConfig.logoUrl;
      this.formItemData.styleConfig.logoUrl = "";
    }
  }
}
